export enum GeneralActionType {
    SHOW_LOADER = 'SHOW_LOADER',
}
